import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const CtaBanner = () => {
  return (
    <section className="sect">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="relative overflow-hidden rounded-[28px] bg-[var(--rs-green)] text-[var(--rs-cream)] p-10 lg:p-16">
          <div className="absolute -top-24 -right-24 w-[420px] h-[420px] rounded-full bg-[var(--rs-coral)]/30 blur-3xl pointer-events-none" />
          <div className="relative grid lg:grid-cols-12 gap-8 items-center">
            <div className="lg:col-span-8">
              <h3 className="h-display text-3xl md:text-5xl leading-tight">
                Outsource the legwork. Spend tomorrow winning new instructions.
              </h3>
              <p className="mt-4 text-[var(--rs-cream)]/75 max-w-xl">
                A 15-minute call is all it takes to set up your branch and start ordering the services your team needs.
              </p>
            </div>
            <div className="lg:col-span-4 flex flex-wrap gap-3 lg:justify-end">
              <Link to="/contact" className="btn-primary">Contact us <ArrowRight className="w-4 h-4" /></Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CtaBanner;
